import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-textile-model-category3s',
  templateUrl: './textile-model-category3s.component.html',
  styleUrls: ['./textile-model-category3s.component.css']
})
export class TextileModelCategory3sComponent implements OnInit {
    public itemsListCategories3: Item[] = [];

    constructor(private datatask: DataTaskService) {

    }

    private async loadCategories3() {
        this.itemsListCategories3 = await this.datatask.Post(2675);
    }

    private async init() {
        this.loadCategories3();
    }

    ngOnInit() {
        this.init();
    }
}
